import { render } from "./TandartsHaaren.vue?vue&type=template&id=034a4539&scoped=true"
import script from "./TandartsHaaren.vue?vue&type=script&lang=js"
export * from "./TandartsHaaren.vue?vue&type=script&lang=js"

import "./TandartsHaaren.vue?vue&type=style&index=0&id=034a4539&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034a4539"]])

export default __exports__